import React from 'react';
import Footer from './Footer';
import Header from './Header'; // Changed import to use default export
import { useLocation } from "react-router-dom";
export const Layout = (props) => {
    const location = useLocation();
    const noLayoutRoutes = ["/QrCode"];          // hide header + footer
    const hideLayout = noLayoutRoutes.some(path =>
        location.pathname.startsWith(path)
    );

    const hideFooterOnRoutes = ["/"];            // hide footer only
    const hideFooter = hideFooterOnRoutes.includes(location.pathname);
    return (
        <>
            {!hideLayout && <Header />}
            <main>
                {props.children}
            </main>
            {!hideLayout && !hideFooter && <Footer />}
        </>
    );
};
export default Layout